import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router-dom';

// import AnalyticsService from './../../services/AnalyticsService';

import Layout from './../layout/Layout';
import Button from './../layout/Button';
import Meta from './../layout/Meta';
import Header from './../layout/Header';

// import DatabaseService from './../../services/DatabaseService';

// import {LAYOUT_SM, LAYOUT_XS } from './../../config';


import {DEMO_SITI} from '../../demodata';

const Proportional = styled.div.withConfig({displayName:'-Proportional'})`
  position: relative;
  width: 100%;
  display: block;
`;
const ProportionalPush = styled.div.withConfig({displayName:'-ProportionalPush'})`
  padding-top: 44.00%;
`;
const ProportionalContent = styled.div.withConfig({displayName:'-ProportionalContent'})`
  position: absolute;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
`;

const Map = styled.div.withConfig({displayName:'-Map'})`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url(/assets/homemap.png);
  background-size: cover;
`;
const MapWrapper = styled.div.withConfig({displayName:'-MapWrapper'})`
  position: relative;
  height: 100%;
  max-width: calc(100% - 30px);
  width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
`;
const Previewer = styled.div.withConfig({displayName:'-Previewer'})`
  position: absolute;
  top: 25px;
  left: 0px;
  width: 300px;
  height: calc(100% - 50px);
  background-color: #ffffff;
  overflow: hidden;
`;
const PreviewerMover = styled.div.withConfig({displayName:'-PreviewerMover'})`
  position: absolute;
  top: 0px;
  left: 0px;
  width: calc(100% * 2);
  height: 100%;
  display: flex;
  flex-direction: row;
  transition: all 0.15s ease-in-out;
  left: ${props => props.moved ? "calc(100% * -1)" : "0"};
`;
const PreviewerPage = styled.div.withConfig({displayName:'-PreviewerPage'})`
  position: relative;
  width: calc(100% / 2);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const PreviewerTopbar = styled.div.withConfig({displayName:'-PreviewerTopbar'})`
  position: relative;
  background-color: #0d609d;
  color: #ffffff;
  padding: 14px;
  text-align: center;
  flex-grow: 0;
  flex-shrink: 0;
`;
const PreviewerTopbarTitle = styled.div.withConfig({displayName:'-PreviewerTopbarTitle'})`
  font-size: 20px;
  font-weight: 500;
`;
const PreviewerTopbarBack = styled.div.withConfig({displayName:'-PreviewerTopbarBack'})`
  position: absolute;
  top: 14px;
  left: 14px;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  width: 26px;
  height: 26px;
  }
`;
const PreviewerContent = styled.div.withConfig({displayName:'-PreviewerContent'})`
  flex-wrap: 1;
  flex-shrink: 1;
  overflow-y: auto;
`;
const PreviewerContentDetail = styled.div.withConfig({displayName:'-PreviewerContentDetail'})`
  position: relative;
  padding: 10px;
`;
const PreviewerContentDetailTitle = styled.div.withConfig({displayName:'-PreviewerContentDetailTitle'})`
  font-size: 16px;
  color: #0D609D;
  line-height: 23px;
  margin-top: 20px;
  font-weight: 500;
`;
const PreviewerContentDetailText = styled.div.withConfig({displayName:'-PreviewerContentDetailText'})`
  font-size: 13px;
  color: #00000099;
  line-height: 18px;
  margin-top: 10px;
  font-weight: 300;
`;



const PreviewerItem = styled.div.withConfig({displayName:'-PreviewerItem'})`
  position: relative;
  padding: 16px 20px;
  border-bottom: 2px solid #F6F6F6;
  cursor: pointer;
  background-color: ${props => props.isHover ? "#f1f1f1" : "#ffffff"};
`;
const PreviewerItemName = styled.div.withConfig({displayName:'-PreviewerItemName'})`
  color: #0D609D;
  font-size: 16px;
  font-weight: 500;
`;
const PreviewerItemRegion = styled.div.withConfig({displayName:'-PreviewerItemRegion'})`
  color: #00000094;
  font-size: 13px;
  font-weight: 300;
`;
const PreviewerItemArrow = styled.div.withConfig({displayName:'-PreviewerItemArrow'})`
  position: absolute;
  top: 26px;
  right: 16px;
  color: #afafaf;
  font-size: 20px;
  `;
const MapMarker = styled.div.withConfig({displayName:'-MapMarker'})`
  width: 2.4%;
  position: absolute;
  top: ${props => props.top}%;
  left: ${props => props.left}%;
  margin-top: -1.2%;
  margin-left: -1.2%;
  cursor: pointer;
`;
const MapMarkerProportional = styled.div.withConfig({displayName:'-MapMarkerProportional'})`
  position: relative;
  width: 100%;
  display: block;
`;
const MapMarkerProportionalPush = styled.div.withConfig({displayName:'-MapMarkerProportionalPush'})`
  padding-top: 99.99%;
`;
const MapMarkerProportionalContent = styled.div.withConfig({displayName:'-MapMarkerProportionalContent'})`
  position: absolute;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // overflow: hidden;
  background-color: ${props => props.isActive ? "#1D559C6B" : "transparent"};;
  border-radius: 100%;
`;
const MapMarkerDot = styled.div.withConfig({displayName:'-MapMarkerDot'})`
  display: block;
  content: "";
  position: absolute;
  top: 30%;
  left: 30%;
  width: 40%;
  height: 40%;
  background-color: ${props => props.isHover && !props.isActive ? "#ffffff" : props.isActive ? "#1D559C" : "#838485"};
  border-radius: 100%;
`;
const MapMarkerLabel = styled.div.withConfig({displayName:'-MapMarkerLabel'})`
  position: absolute;
  top: -50%;
  left: 50%;
  opacity: 0;
  display: none;
  transform: translate(-50%,-50%);
  padding: 4px 10px;
  background-color: #1D559C;
  color: #ffffff;
  font-weight: bold;
  transition: all 0.25s ease-in-out;
  white-space: nowrap;
  z-index: 99;

  display: ${props => props.isHover ? "block" : "none"};
  opacity: 1;

  &::after{
    content: "";
    display: block;
    position: absolute;
    top: 100%;
    left: calc(50% - 7px);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid #1D559C;
  }
`;

const HomePage = ({layout}) => {
  let { lang } = useParams();

  const [hoverSite, setHoverSite] = useState(null);
  const [activeSite, setActiveSite] = useState(null);

  // useEffect(() => {
  //   AnalyticsService.init();  
  // }, []);

  useEffect(() => { 
    // DatabaseService.getEvents({
    //   status: "next",
    //   order: "asc"
    // }).then((response) => {
    //   if(response.success){
    //     setEventsNext(response.data);
    //   }else{
    //     console.log(response.error);
    //   }
    // });
  }, []);

  return (
    <Layout layout={layout}>
      <Meta
        languages={{"it": ""}}
      />
      
      <Header 
        src="/assets/header-home.jpg" 
        upperText={"BO.RI.S. - Bonifiche e Risanamento Siti"}
        title={"WEB GIS - Banca dati ambientali"}
        lowerText={"Centrali Termoelettriche Enel - Country Italia"}
        isHome={true}
      />

      <Proportional>
        <ProportionalPush />
        <ProportionalContent>
          <Map>
            <MapWrapper>
              <Previewer>
                <PreviewerMover moved={activeSite !== null}>
                  <PreviewerPage>
                    <PreviewerTopbar>
                      <PreviewerTopbarTitle>Siti d'interesse</PreviewerTopbarTitle>
                    </PreviewerTopbar>
                    <PreviewerContent>
                      {Object.keys(DEMO_SITI).map(i => 
                        <PreviewerItem
                          key={i}
                          onMouseEnter={() => setHoverSite(i)}
                          onMouseLeave={() => setHoverSite(null)}
                          onClick={() => setActiveSite(i)}
                          isHover={hoverSite === i}
                        >
                          <PreviewerItemName>{DEMO_SITI[i].name}</PreviewerItemName>
                          <PreviewerItemRegion>{DEMO_SITI[i].region}</PreviewerItemRegion>
                          <PreviewerItemArrow><i className="fa-solid fa-chevron-right"></i></PreviewerItemArrow>
                        </PreviewerItem>
                      )}                      
                    </PreviewerContent>
                  </PreviewerPage>
                  <PreviewerPage>
                    <PreviewerTopbar>
                      <PreviewerTopbarBack
                        onClick={() => setActiveSite(null)}
                      ><i className="fa-solid fa-chevron-left"></i></PreviewerTopbarBack>
                      {activeSite !== null ? 
                        <PreviewerTopbarTitle>{DEMO_SITI[activeSite].name}</PreviewerTopbarTitle>
                      : null }
                    </PreviewerTopbar>
                    <PreviewerContent>
                      {activeSite !== null ? 
                        <PreviewerContentDetail>
                          <img src={"/assets/sites-thumbs/"+activeSite+".jpg"} width="100%" alt={activeSite}/>
                          <PreviewerContentDetailTitle>{DEMO_SITI[activeSite].detailTitle}</PreviewerContentDetailTitle>
                          <PreviewerContentDetailText>{DEMO_SITI[activeSite].detailText}</PreviewerContentDetailText>
                          <br/>
                          {activeSite === "santa-barbara" ? 
                            <center>
                              <Button to={"/"+lang+"/siti/"+activeSite}>Guarda la scheda</Button>
                            </center>
                          : null }
                        </PreviewerContentDetail>     
                      : null }                                  
                    </PreviewerContent>
                  </PreviewerPage>
                </PreviewerMover>
              </Previewer>
              
            </MapWrapper>
            {Object.keys(DEMO_SITI).map(i => 
              <MapMarker top={DEMO_SITI[i].top} left={DEMO_SITI[i].left} key={i}>
                <MapMarkerProportional>
                  <MapMarkerProportionalPush />
                  <MapMarkerProportionalContent
                    isActive={activeSite === i}
                  >
                    <MapMarkerDot 
                      onMouseEnter={() => setHoverSite(i)}
                      onMouseLeave={() => setHoverSite(null)}
                      onClick={() => setActiveSite(i)}
                      isHover={hoverSite === i}
                      isActive={activeSite === i}
                    />
                    <MapMarkerLabel
                      isHover={hoverSite === i}
                    >{DEMO_SITI[i].name}</MapMarkerLabel>
                  </MapMarkerProportionalContent>
                </MapMarkerProportional>
              </MapMarker>
            )} 
          </Map>
        </ProportionalContent>

      </Proportional>

    </Layout>
  )
}

export default HomePage
